import { Component, ViewEncapsulation, computed, input } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { CfiMatTableComponent } from '@k12/tables';
import type { ColumnDefinition } from '@k12/tables';
import { CwFileTransaction } from '../../../awards/models/cw-file-transaction.model';

export interface ClassWalletTransaction {
  studentPID: string;
  expenseFileDate: Date | null;
  academicYear: string | number | null;
  term: string;
  program: string;
  description: string;
  orderId: string;
  taxable: string;
  walletExpenseAmount: number;
}

@Component({
  selector: 'cfi-student-class-wallet-ledger-detail',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, CurrencyPipe, DatePipe, CfiMatTableComponent],
  templateUrl: './student-class-wallet-ledger-detail.html',
  styleUrls: ['./student-class-wallet-ledger-detail.scss'],
})
export class StudentClassWalletLedgerDetailComponent {
  readonly transactions = input<CwFileTransaction[] | null>([]);

  readonly rows = computed<ClassWalletTransaction[]>(() =>
    (this.transactions() ?? []).map((transaction) => this.mapTransaction(transaction))
  );

  readonly columnDefinitions: ColumnDefinition[] = [
    { name: 'expenseFileDate', header: 'Expense File Date', sortable: true, width: 16 },
    { name: 'academicYear', header: 'Academic Year', sortable: true, width: 16 },
    { name: 'term', header: 'Term', sortable: true, width: 12 },
    { name: 'program', header: 'Program', sortable: true, width: 16 },
    { name: 'description', header: 'Description', sortable: true, width: 20 },
    { name: 'orderId', header: 'Order Id', sortable: true, width: 16 },
    { name: 'taxable', header: 'Taxable', sortable: true, width: 12 },
    { name: 'walletExpenseAmount', header: 'Wallet Expense Amount', sortable: true, width: 16 },
  ];

  readonly displayedColumns: string[] = this.columnDefinitions.map(col => col.name);

  public get runningBalance(): number {
    return this.rows().reduce((sum, transaction) => sum + (transaction.walletExpenseAmount ?? 0), 0);
  }

  private mapTransaction(transaction: CwFileTransaction): ClassWalletTransaction {
    const expenseFileDate = transaction.expenseFileDate;

    return {
      studentPID: transaction.studentPID ?? '',
      expenseFileDate: expenseFileDate ? new Date(expenseFileDate) : null,
      academicYear: transaction.academicYear ?? null,
      term: transaction.term ?? '',
      program: transaction.program ?? '',
      description: transaction.expenseDescription ?? '',
      orderId: transaction.orderId ?? '',
      taxable: transaction.taxable ?? '',
      walletExpenseAmount: transaction.walletExpenseAmount ?? 0
    };
  }
}
